module.exports = __webpack_public_path__ + "img/map-pin-check-inside.f5f88156.svg";